import { Shimmer } from '@components/shimmer.component';
import { FooterLayout } from './_footer_layout.component';

export function FooterSkeleton(): JSX.Element {
	return (
		<FooterLayout
			addressInfoSection={<Shimmer height={16} width={100} cornerRadius={8} />}
			externalLinkSection={<Shimmer height={16} width={100} cornerRadius={8} />}
			infoTextSection={<Shimmer height={16} width={100} cornerRadius={8} />}
			legalSection={<Shimmer height={16} width={100} cornerRadius={8} />}
			appSection={<Shimmer height={16} width={100} cornerRadius={8} />}
		/>
	);
}
